import { CHECKOUT_ROUTES } from 'domains/Billing/Checkout/checkoutRoutes';
import { NUVEM_PAGO_COMMONS_ROUTES } from './nuvemPagoCommonsRoutes';

const createRoutePattern = (route: string): RegExp =>
  new RegExp(`^${route.replace(/:\w+/g, '[^/]+')}$`);

export const UNLOCKED_ROUTE_PATTERNS = [
  /^\/account/,
  createRoutePattern(CHECKOUT_ROUTES.choosePaymentMethodForPayOrder),
  createRoutePattern(CHECKOUT_ROUTES.payWithCreditCard),
  createRoutePattern(NUVEM_PAGO_COMMONS_ROUTES.blockedAlert),
];

export const NUVEMPAGO_TRANSPARENT_CHECKOUT_IN_ADVANCED_SETTINGS_FEATURE_FLAG =
  'fs-nuvempago-set-transparent-checkout-in-advanced-settings';

export const NUVEMPAGO_ACTIVE_STATUS_TAG_FOR_NEW_COHORTS_FEATURE_FLAG =
  'fs-nuvempago-active-status-tag-for-new-cohorts';
